import { pushToDataLayer } from '@/lib/pushToDataLayer.ts';

export const trackFormStart = () => {
  pushToDataLayer({
    event: 'form_start',
  });
};
